export interface WatchTowerPupilPoint {
  x: number,
  y: number,
}

export interface WatchTowerRectLike {
  left: number,
  top: number,
  width: number,
  height: number,
}

export const WATCH_TOWER_PUPIL_REST_X = 0.4;
export const WATCH_TOWER_PUPIL_REST_Y = 0.25;
export const WATCH_TOWER_PUPIL_MAX_X = 1.15;
export const WATCH_TOWER_PUPIL_MAX_Y = 0.9;
export const WATCH_TOWER_PUPIL_MIN_X = -0.45;
export const WATCH_TOWER_PUPIL_GAIN = 0.5;

function clamp(value: number, min: number, max: number): number {
  return Math.min(max, Math.max(min, value));
}

export function watchTowerPupilOffset(
  clientX: number,
  clientY: number,
  icon: WatchTowerRectLike,
  panel: WatchTowerRectLike,
): WatchTowerPupilPoint {
  if (icon.width <= 0 || icon.height <= 0 || panel.width <= 0 || panel.height <= 0) {
    return { x: WATCH_TOWER_PUPIL_REST_X, y: WATCH_TOWER_PUPIL_REST_Y };
  }
  const iconCx = icon.left + icon.width / 2;
  const iconCy = icon.top + icon.height / 2;
  const nx = ((clientX - iconCx) / (panel.width / 2)) * WATCH_TOWER_PUPIL_GAIN;
  const ny = ((clientY - iconCy) / (panel.height / 2)) * WATCH_TOWER_PUPIL_GAIN;
  return {
    x: clamp(
      WATCH_TOWER_PUPIL_REST_X + clamp(nx, -1, 1) * WATCH_TOWER_PUPIL_MAX_X,
      WATCH_TOWER_PUPIL_MIN_X,
      WATCH_TOWER_PUPIL_MAX_X + WATCH_TOWER_PUPIL_REST_X,
    ),
    y: clamp(
      WATCH_TOWER_PUPIL_REST_Y + clamp(ny, -1, 1) * WATCH_TOWER_PUPIL_MAX_Y,
      -WATCH_TOWER_PUPIL_MAX_Y,
      WATCH_TOWER_PUPIL_MAX_Y + WATCH_TOWER_PUPIL_REST_Y,
    ),
  };
}
